import { render, staticRenderFns } from "./LifestyleProduct.vue?vue&type=template&id=654dc230&scoped=true&"
import script from "./LifestyleProduct.vue?vue&type=script&lang=js&"
export * from "./LifestyleProduct.vue?vue&type=script&lang=js&"
import style0 from "./LifestyleProduct.vue?vue&type=style&index=0&id=654dc230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654dc230",
  null
  
)

export default component.exports